import React, { useContext, useCallback, useEffect } from 'react'
import Key from './Key'
import { AppContext } from '../App'

function Keyboard() {
	const { onEnter, onDelete, onSelectLetter, disabledLetters, setDisabledLetters, correctLetters, almostLetters } = useContext(AppContext)
	const keys1 = ["ض", "ص", "ث", "ق", "ف", "غ", "ع", "ه", "خ", "ح", "ج"]
	const keys2 = ["ش", "س", "ي", "ب", "ل", "ا", "ت", "ن", "م", "ك", "ة"]
	const keys3 = ["ء", "ظ", "ط", "ذ", "د", "ز", "ر", "و"]
	const handleKeyboard = useCallback(event => {
		if (event.key === "Enter") {
			onEnter()
		}
		if (event.key === "Backspace") {
			onDelete()
		}
	})
	useEffect(() => {
		document.addEventListener("keydown", handleKeyboard)

		return () => {
			document.removeEventListener("keydown", handleKeyboard)
		}
	}, [handleKeyboard])
	return (
		<div className="keyboard">
			<div className="line1">{keys1.map((key) => {
				return <Key keyVal={key} disabled={disabledLetters.includes(key)} correct={correctLetters.includes(key)} almost={almostLetters.includes(key)} />
			})}</div>
			<div className="line2">{keys2.map((key) => {
				return <Key keyVal={key} disabled={disabledLetters.includes(key)} correct={correctLetters.includes(key)} almost={almostLetters.includes(key)} />
			})}</div>
			<div className="line3">
			<Key keyVal="↩" bigKey />
			{keys3.map((key) => {
				return <Key keyVal={key} disabled={disabledLetters.includes(key)} correct={correctLetters.includes(key)} almost={almostLetters.includes(key)} />
			})}
			<Key keyVal="⌦" bigKey />
			</div>
		</div>
		)
}

export default Keyboard;

